export const locale = {
    lang: "en",
    data: {
        TAXS: {
            TAX: "STATE TAX",
        },
    },
};
